var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcMove(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M629 216c17 18 17 35 0 52s-34 17-52 0l-41-41 1 237 236-1-41-40c-14-21-14-38 0-52s31-14 52 0l129 129-129 129c-18 17-35 17-52 0s-17-35 0-52l41-41H537l-1 237 41-41c21-14 38-14 52 0s14 31 0 52L500 913 371 784c-17-18-17-35 0-52s35-17 52 0l41 41V536H227l41 41c14 20 14 38 0 52s-31 14-52 0L88 500l128-129c18-17 35-17 52 0s17 34 0 52l-41 40 237 1V227l-41 41c-20 14-38 14-52 0s-14-31 0-52L500 87l129 129z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMove);
export default __webpack_public_path__ + "static/media/ic_move.f57e3032835106e5727c5bab961a5cfe.svg";
export { ForwardRef as ReactComponent };